export default __webpack_public_path__ + "images/image-C1qla.png";